export function clamp(n: number, min: number, max: number) {
  return Math.min(Math.max(n, min), max);
}

function getOrdinalSuffix(n) {
  const cent = n % 100;
  if (cent >= 10 && cent <= 20) {
    return "th";
  }
  // Due to the way these cases visually align, this is actually more readable without curlies
  /* eslint-disable curly */
  const dec = n % 10;
  if (dec === 1) return "st";
  if (dec === 2) return "nd";
  if (dec === 3) return "rd";
  return "th";
  /* eslint-enable curly */
}

// Fraction does not seem to localize these at this time
export function formatOrdinal(n: number): string {
  return `${n}${getOrdinalSuffix(n)}`;
}

/**
 * Generate a random integer from min to max, inclusive
 */
export const randomNumber = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
};
